import fetch, { parseListResponse } from "./fetch";

export interface GroupInterface {
    id: string;
    name: string;
    normalized_name: string;
}

class Group {
    all(params?: HashMap<any>) {
        return parseListResponse<GroupInterface>(fetch.get(`groups/`, { params }));
    }
}

export default new Group();
